var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTelegram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 26,
    viewBox: "0 0 30 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.3391 1.17714C27.3391 1.17714 30.091 0.104014 29.8608 2.70997C29.785 3.7831 29.0972 7.53939 28.5617 11.6017L26.7271 23.6363C26.7271 23.6363 26.5741 25.3993 25.1978 25.706C23.8222 26.012 21.7581 24.6329 21.3756 24.3262C21.0696 24.096 15.6424 20.6464 13.7313 18.9606C13.1958 18.5001 12.5838 17.5807 13.8078 16.5076L21.8339 8.84201C22.7512 7.9226 23.6685 5.77635 19.8464 8.38231L9.14344 15.664C9.14344 15.664 7.92015 16.4311 5.62727 15.7412L0.657607 14.2076C0.657607 14.2076 -1.17698 13.058 1.9574 11.9084C9.60244 8.30581 19.0056 4.62672 27.3377 1.17714H27.3391Z",
    fill: "black",
    fillOpacity: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegram);
export default __webpack_public_path__ + "static/media/telegram.54d33a13ce867bb0d822620707fe11ee.svg";
export { ForwardRef as ReactComponent };